import type { DSDiscoveryNewPage } from 'shared-definitions/types'
import type { ApiPageDiscoveryNewProps } from '../types.wp'
import { headPropsMapper } from './headPropsMapper'
import { MetaMapperOpts, metaMapper } from './metaMapper'
import { additionalFilterMapper } from './additionalFilterMapper'

interface CodecDiscoveryNewPageOpts extends MetaMapperOpts {
  pagePath: string
}

export function codecDiscoveryNewPage(
  { content, head }: ApiPageDiscoveryNewProps,
  opts: CodecDiscoveryNewPageOpts
): DSDiscoveryNewPage {
  return {
    resource: 'discovery-new-page',
    head: headPropsMapper(head),
    ampPagePath: null,
    sections: null,
    meta: metaMapper({ ...content, categories: [], tags: [] }, [content.title], opts),
    pagePath: opts.pagePath,
    title: content.title,
    filters: {
      title: 'Filter',
      clearLabel: 'Clear all',
      info: {
        search: {
          title: 'Search',
          placeholder: 'Search for products',
        },
        brands: {
          title: 'Brands',
          buttonLabelLess: 'Show less',
          buttonLabelMore: 'Show more',
          options:
            content.discover.brands?.flatMap(brand => ({
              id: brand.id.toString(),
              title: brand.name,
              featured: brand.popular,
            })) ?? [],
        },
        categories: content.discover.categories.options.map(category => ({
          name: category.name,
          value: category.value.toString(),
        })),
        ratingTypes: [
          Object.assign(content.discover.admin_rating, { type: 'admin_rating' }),
          // temporary remove user rating
          // Object.assign(content.discover.user_rating, { type: 'user_rating' }),
        ].map(ratingType => ({
          name: ratingType.title,
          value: ratingType.type,
          constraints: ratingType.value,
        })),
        ratingFeatures: {
          title: content.discover.ratings.title,
          options: content.discover.ratings.options.map(rating => ({
            icon: rating.image ?? 'speakers',
            title: rating.name,
            value: rating.value?.toString() ?? null,
          })),
        },
        priceRanges: {
          constraints: content.discover.price_range.value,
          title: content.discover.price_range.title,
        },
        additional: {
          title: 'Additional Filters',
          list: content.discover.additional_filters?.map(additionalFilterMapper) ?? [],
        },
      },
    },
    sort: {
      ratingOption: content.discover.sort.rating_option,
      title: content.discover.sort.title,
      options: content.discover.sort.options.map(sort => ({
        name: sort.name,
        value: sort.value,
      })),
    },
    results: {
      recommendTitle: 'recommendation',
    },
    defaultFilter: {
      page: 1,
      perPage: 24,
      searchTerms: [],
      brand: [],
      category: content.discover.categories.options
        .filter(category => category.is_selected)
        .map(category => category.value.toString()),
      priceRange: null,
      ratingFeatures: [],
      ratings: [],
      sort: { field: content.discover.sort.options[0].value, order: 'desc' },
      additional: {},
    },
  }
}
